import PropTypes from "prop-types"
import { Button } from "@planningcenter/tapestry-react"

const AddDateTimeButton = ({ handleAddition }) => {
  const handleClick = e => {
    e.preventDefault()
    handleAddition()
  }

  return <Button size="sm" variant="outline" onClick={handleClick} title="Add date/time" />
}

AddDateTimeButton.propTypes = {
  handleAddition: PropTypes.func.isRequired
}

export default AddDateTimeButton
